module.exports = __webpack_public_path__ + "img/thumb_23.4b04ab3e.jpg";